import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CheckItemModel } from './check-item-model.interface';

@Component({
  selector: 'app-check-item',
  templateUrl: './check-item.component.html',
  styleUrls: ['./check-item.component.scss'],
  standalone: false
})
export class CheckItemComponent {
  @Input() highlightOnChecked: boolean;
  @Input() model: CheckItemModel;

  @Output() changed = new EventEmitter<void>();

  onChange() {
    this.changed.next();
  }

}
